export default __webpack_public_path__ + "static/media/kycArtYellow.701ce9c4.png";